module.exports = __webpack_public_path__ + "static/media/presupuesto_colocacion.0f64da9e.jpg";